var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
import { isSegmentSteady, Status, SegmentType } from 'navi';
import { NavSegment } from './NavSegment';

function isFinalSegment(segment) {
  return segment.status === Status.Busy || segment.type !== SegmentType.Switch;
}

function isReady(segment) {
  return isSegmentSteady(segment);
}

var NavRoute =
/** @class */
function (_super) {
  __extends(NavRoute, _super);

  function NavRoute() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderChildren = function (output) {
      var render;

      if (_this.props.children) {
        render = _this.props.children;

        if (typeof render !== "function") {
          throw new Error("<NavRoute> expects its children to be a function, but instead received \"" + render + "\".");
        }
      } else if (output.route && output.route.content) {
        var content = output.route.content;

        if (typeof content === 'function') {
          render = output.route.content;
        } else if (React.isValidElement(content)) {
          return content;
        }
      } // If the route content is still loading, just render nothing --
      // this allows SPAs to get away without waiting for `navigation.steady()`
      // on the initial load.


      if (output.route && output.route.status === Status.Busy) {
        return null;
      }

      if (!render) {
        throw new Error("<NavRoute> was not able to find a `children` prop, or a `render` function in the consumed segment's `content`.");
      }

      return render(output.route);
    };

    return _this;
  }

  NavRoute.prototype.render = function () {
    return React.createElement(NavSegment, {
      where: isFinalSegment,
      isReady: isReady,
      children: this.renderChildren
    });
  };

  return NavRoute;
}(React.Component);

export { NavRoute };